import {
  Component,
  DestroyRef,
  OnDestroy,
  OnInit,
  ViewChild,
  effect,
  inject,
  signal,
} from "@angular/core";
import { BooksReviewService } from "./books-review.service";
import { WorkspacesService } from "../workspaces.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

import { TableModule } from "primeng/table";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { BsDropdownDirective, BsDropdownModule } from "ngx-bootstrap/dropdown";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { QuickbooksIntegrationService } from "src/app/dashboard/quickbooks-integration.service";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";

import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  NavigationEnd,
  NavigationStart,
  Router,
  RouterModule,
  RouterStateSnapshot,
} from "@angular/router";
import { DatePickerModule } from "primeng/datepicker";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { DropdownModule } from "primeng/dropdown";
import { HotToastService } from "@ngneat/hot-toast";
import moment from "moment";
import { filter, Observable } from "rxjs";

// create interface for time frame filter
export interface TimeFrameFilter {
  timeFrame: string | string[];
  startDate: any;
  endDate: any;
}

export interface ReviewedFilter {
  name: string;
  value: boolean;
}

export interface ToolData {
  start_date: string;
  end_date: string;
  transactions: Transaction[];
}

export interface Transaction {
  id: number | string;
  name: string;
  amount: number | string;
  account: string;
  category: string;
  quantity: number;
  class: string;
  selectedClass: string;
  payee: string;
  payment_date: string;
  purchase_id: string;
  selectedAcc: string;
  realmId: string;
}

@Component({
  selector: "page-books-review",
  imports: [
    RouterModule,
    TableModule,
    CommonModule,
    FormsModule,
    BsDropdownModule,
    TooltipModule,
    TypeaheadModule,
    DatePickerModule,
    DropdownModule,
  ],
  templateUrl: "./books-review.component.html",
  styleUrl: "./books-review.component.scss",
})
export class BooksReviewComponent implements OnInit, OnDestroy {
  booksReviewService = inject(BooksReviewService);
  workspacesService = inject(WorkspacesService);
  quickbooksIntegrationService = inject(QuickbooksIntegrationService);
  localStorageService = inject(LocalStorageService);
  toastr = inject(HotToastService);
  router = inject(Router);
  localStorage = inject(LocalStorageService);
  activatedRoute = inject(ActivatedRoute);

  constructor() {
    effect(() => {
      const url = this.currentUrl();
      if (
        url.includes("balance-sheet-review") ||
        url.includes("profit-and-loss-review")
      ) {
        this.showReviewedHeader.set(false);
        this.onBalanceSheetReviewActivated();
      } else {
        this.showReviewedHeader.set(true);
      }
    });
  }

  timeFrames = [
    { label: "Last week", value: "last_week" },
    { label: "Last two weeks", value: "last_two_weeks" },
    { separator: true },
    { label: "Last month", value: "last_month" },
    { label: "Last two months", value: "last_two_months" },
    { label: "Last three months", value: "last_three_months" },
    { separator: true },
    { label: "Last quarter", value: "last_quarter" },
    { label: "Last year", value: "last_year" },
    { separator: true },
    { label: "This week", value: "this_week" },
    { label: "This month", value: "this_month" },
    { label: "This year", value: "this_year" },
  ];

  isChildRouteActive: boolean = false;

  currentUrl = signal<string>("");
  showEmptyState = signal<boolean>(true);
  showReviewedHeader = signal<boolean>(true);

  @ViewChild("dropdown") dropdown: BsDropdownDirective;

  companyAccounts: any;
  companyVendors: any;
  date: any = null;
  displayTimeFrameFilter: string | string[] = "This month";
  timeFrameFilter: string | string[] = null;
  formatedTimeFrame: string = "\xa0";
  reviewedFilter: { name: string; value: boolean } = {
    name: "Not Reviewed",
    value: false,
  };

  reviewOptions = [
    { name: "Reviewed", value: true },
    { name: "Not Reviewed", value: false },
  ];

  company: any;

  data = [];

  readonly destroyRef = inject(DestroyRef);

  ngOnInit() {
    let dateFilter = this.localStorageService.get("dateFilter");
    this.localStorage.set("last_tab", "books-review");

    if (this.localStorage.get("last_tool") != null) {
      this.router.navigate([`./${this.localStorage.get("last_tool")}`], {
        relativeTo: this.activatedRoute,
      });
    }

    console.log(dateFilter);
    if (dateFilter != null) {
      this.date = [];
      this.date.push(dateFilter.startDate);
      this.date.push(dateFilter.endDate);

      this.changeTimeFrameFilter(dateFilter.timeFrame);
    } else {
      this.changeTimeFrameFilter("this_month");
    }

    this.reviewedFilter = {
      value: false,
      name: "Not Reviewed",
    };

    this.workspacesService.$hasQBOIntegration
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((hasQBOIntegration) => {
        if (!hasQBOIntegration) {
          this.workspacesService.switchActiveTab.next({
            tab: "conversations",
            payload: {},
          });
        }
      });

    this.booksReviewService.dateSelected$.next(this.date);

    this.workspacesService.$company
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((company) => {
        if (company == null) return;

        this.company = company;

        this.quickbooksIntegrationService
          .getAccountsByCompanyId(this.company.id)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((res) => {
            this.companyAccounts = res;
            this.booksReviewService.companyAccounts = this.companyAccounts;
            this.booksReviewService.companyAccounts$.next(this.companyAccounts);
            console.log("accounts", this.companyAccounts);
          });

        this.quickbooksIntegrationService
          .getVendorsByCompanyId(this.company.id)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((res) => {
            console.log("quickbooks vendors", res);
            this.companyVendors = res;
            this.booksReviewService.companyVendors = this.companyVendors;
            this.booksReviewService.companyVendors$.next(this.companyVendors);
          });
        console.log("workspaceID", this.company.id);
        this.quickbooksIntegrationService.retrieveClasses(this.company.id).then(
          (res) => {
            this.booksReviewService.hasClassesEnabled = res.enabled;
            this.booksReviewService.companyClasses = res.classes;
            this.booksReviewService.companyClasses$.next(res.classes);
          },
          (err) => {
            if (err.status == 404) {
              this.booksReviewService.hasClassesEnabled = false;
            }
          },
        );
      });

    this.booksReviewService.onToolChange$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.reviewedFilter = {
          name: "Not Reviewed",
          value: false,
        };

        this.booksReviewService.reviewedFilter = this.reviewedFilter;
      });

    this.router.events
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.currentUrl.set(this.router.url);
        this.isChildRouteActive = !!this.activatedRoute.firstChild;
        this.showEmptyState.set(!this.isChildRouteActive);
      });
  }

  shouldDisplayTimeFrame(value: string) {
    const currentUrl = this.currentUrl();
    if (
      currentUrl.includes("balance-sheet-review") ||
      currentUrl.includes("profit-and-loss-review")
    ) {
      return (
        value === "last_month" ||
        value === "last_quarter" ||
        value === "last_year"
      );
    }
    return true;
  }

  onBalanceSheetReviewActivated() {
    const filters = ["last_month", "last_quarter", "last_year"];
    if (!filters.includes(this.timeFrameFilter as string)) {
      this.changeTimeFrameFilter("last_month");
    }
  }

  accountSelected(event, item) {
    item.account_id = event.id;
  }

  ngOnDestroy(): void {
    // No need to manually unsubscribe
  }

  async updateTransaction(transaction) {
    let res = await this.booksReviewService.updateTransaction(
      this.company.uuid,
      transaction,
    );
  }

  onDateChange(isCustomDate = false): void {
    if (isCustomDate) this.timeFrameFilter = "custom_date";

    if (
      this.timeFrameFilter == "custom_date" &&
      this.date.filter((d) => d != null).length != 2
    )
      return;
    this.booksReviewService.dateFilter.timeFrame = this.timeFrameFilter;

    this.localStorageService.set(
      "dateFilter",
      this.booksReviewService.dateFilter,
    );

    this.booksReviewService.dateSelected$.next(
      this.booksReviewService.dateFilter,
    );
  }

  changeTimeFrameFilter(change: string[] | string): void {
    this.timeFrameFilter = change;

    if (this.timeFrameFilter == "this_week") {
      this.displayTimeFrameFilter = "This week";
      this.date = null;
      this.formatedTimeFrame = `${moment().startOf("isoWeek").format("MMM D, YYYY")} to ${moment().endOf("isoWeek").format("MMM D, YYYY")}`;
    }

    if (this.timeFrameFilter == "this_month") {
      this.displayTimeFrameFilter = "This month";
      this.date = null;
      this.formatedTimeFrame = `${moment().startOf("month").format("MMM D, YYYY")} to ${moment().endOf("month").format("MMM D, YYYY")}`;
    }

    if (this.timeFrameFilter == "last_two_months") {
      this.displayTimeFrameFilter = "Last 2 months";
      this.date = null;
      this.formatedTimeFrame = `${moment().subtract(2, "months").startOf("month").format("MMM D, YYYY")} to ${moment().subtract(1, "months").endOf("month").format("MMM D, YYYY")}`;
    }

    if (this.timeFrameFilter == "last_three_months") {
      this.displayTimeFrameFilter = "Last 3 months";
      this.date = null;
      this.formatedTimeFrame = `${moment().subtract(3, "months").startOf("month").format("MMM D, YYYY")} to ${moment().subtract(1, "months").endOf("month").format("MMM D, YYYY")}`;
    }

    if (this.timeFrameFilter == "last_year") {
      this.displayTimeFrameFilter = "Last year";
      this.date = null;
      this.formatedTimeFrame = `${moment().subtract(1, "year").startOf("year").format("MMM D, YYYY")} to ${moment().subtract(1, "year").endOf("year").format("MMM D, YYYY")}`;
    }

    if (this.timeFrameFilter == "last_quarter") {
      this.displayTimeFrameFilter = "Last quarter";
      this.date = null;
      const currentQuarter = moment().quarter();
      this.formatedTimeFrame = `${moment()
        .quarter(currentQuarter - 1)
        .startOf("quarter")
        .format("MMM D, YYYY")} to ${moment()
        .quarter(currentQuarter - 1)
        .endOf("quarter")
        .format("MMM D, YYYY")}`;
    }

    if (this.timeFrameFilter == "today") {
      this.displayTimeFrameFilter = "Today";
      this.date = null;
    }

    if (this.timeFrameFilter == "last_week") {
      this.displayTimeFrameFilter = "Last week";
      this.date = null;
      this.formatedTimeFrame = `${moment().subtract(1, "week").startOf("isoWeek").format("MMM D, YYYY")} to ${moment().subtract(1, "week").endOf("isoWeek").format("MMM D, YYYY")}`;
    }

    if (this.timeFrameFilter == "last_two_weeks") {
      this.displayTimeFrameFilter = "Last two weeks";
      this.date = null;
      this.formatedTimeFrame = `${moment().subtract(2, "weeks").startOf("isoWeek").format("MMM D, YYYY")} to ${moment().subtract(1, "week").endOf("isoWeek").format("MMM D, YYYY")}`;
    }

    if (this.timeFrameFilter == "last_four_weeks") {
      this.displayTimeFrameFilter = "Last four weeks";
      this.date = null;
      this.formatedTimeFrame = `${moment().subtract(4, "weeks").startOf("isoWeek").format("MMM D, YYYY")} to ${moment().subtract(1, "week").endOf("isoWeek").format("MMM D, YYYY")}`;
    }

    if (this.timeFrameFilter == "last_month") {
      this.displayTimeFrameFilter = "Last month";
      this.date = null;
      this.formatedTimeFrame = `${moment().subtract(1, "month").startOf("month").format("MMM D, YYYY")} to ${moment().subtract(1, "month").endOf("month").format("MMM D, YYYY")}`;
    }

    if (this.timeFrameFilter == "custom_date") {
      console.log("setting custom_date", this.date);
      if (this.date != null && this.date.filter((d) => d != null).length == 2) {
        this.booksReviewService.dateFilter.startDate = this.date[0];
        this.booksReviewService.dateFilter.endDate = this.date[1];
        this.localStorageService.set(
          "dateFilter",
          this.booksReviewService.dateFilter,
        );
        this.displayTimeFrameFilter = `Custom date range`;
        this.formatedTimeFrame = `${moment(this.date[0]).format("MMM D, YYYY")} to ${moment(this.date[1]).format("MMM D, YYYY")}`;
        if (this.dropdown != null) {
          this.dropdown.hide();
        }
      }
    }

    if (this.timeFrameFilter == "this_year") {
      this.displayTimeFrameFilter = "This year";
      this.date = null;
      this.formatedTimeFrame = `${moment().startOf("year").format("MMM D, YYYY")} to ${moment().endOf("year").format("MMM D, YYYY")}`;
    }
  }

  onReviewedFilterChange(type: string) {
    if (type === "reviewed") {
      this.reviewedFilter = {
        name: "Reviewed",
        value: true,
      };
    } else {
      this.reviewedFilter = {
        name: "Not Reviewed",
        value: false,
      };
    }
    this.booksReviewService.reviewedFilter = this.reviewedFilter;
    console.log(
      "reviewedFilter",
      this.booksReviewService.reviewedFilter,
      this.reviewedFilter,
    );
    this.localStorageService.set("reviewedFilter", this.reviewedFilter);
    this.booksReviewService.dateSelected$.next(
      this.booksReviewService.dateFilter,
    );
  }

  refreshLists() {
    this.quickbooksIntegrationService.refreshCache(this.company.id).subscribe(
      () => {
        // trigger refresh
        this.quickbooksIntegrationService
          .getAccountsByCompanyId(this.company.id)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((res) => {
            this.companyAccounts = res;
            console.log("accounts", this.companyAccounts);
          });

        this.quickbooksIntegrationService
          .getVendorsByCompanyId(this.company.id)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((res) => {
            console.log("quickbooks vendors", res);
            this.companyVendors = res;
          });

        this.toastr.success(
          "Accounts, Vendors and Classes will be refreshed shortly.",
        );
      },
      (error) => {
        this.toastr.error(
          "Error refreshing your connection. Please remove this connection and try again.",
        );
      },
    );
  }

  onToolChange() {
    this.booksReviewService.reviewedFilter = {
      name: "Not Reviewed",
      value: false,
    };
  }
}
